import type { ReceiptTemplate } from '../schema';

export const costcoTemplate: ReceiptTemplate = {
  id: 'costco',
  name: 'Costco Receipt',
  brand: 'Costco',
  description: 'Realistic Costco Wholesale receipt template',
  settings: {
    width: 250,
    font: 'Bit Matrix C',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#000000',
    showWatermark: false,
    currency: 'none',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'costco-top-divider',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 14,
      },
    },
    {
      id: 'costco-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/costco.png',
        logoData: '',
        logoWidth: 180,
        logoHeight: 50,
        businessName: ' ',
        businessNameFontSize: 24,
        addressLines: [
          'Monsterville #629',
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'costco-member',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '2X Member 672183513281',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'costco-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: false,
        quantityPosition: 'left',
        showHeader: false,
        showHeaderDivider: false,
        headerLabels: {
          quantity: 'Qty',
          item: 'Item',
          amount: 'Price',
        },
        items: [
          { id: 'costco-item-1', name: 'E     4046 AVOCADO', price: '0.95 E' },
          { id: 'costco-item-2', name: 'E   203717 GV MILK 2%', price: '3.64 E' },
          { id: 'costco-item-3', name: 'E   210834 GV BREAD WH', price: '1.28 E' },
          { id: 'costco-item-4', name: 'E   212063 GV EGGS LG', price: '4.87 E' },
          { id: 'costco-item-5', name: '    096478 TIDE PODS', price: '14.97 A' },
        ],
        showTopDivider: false,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'costco-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 15,
        lines: [
          { id: 'costco-subtotal', label: 'SUBTOTAL', value: '25.71  ', isBold: false, isLarge: false },
          { id: 'costco-tax', label: 'TAX', value: '1.80  ', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 40,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'costco-total-inverted',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 0,
        lines: [
          { id: 'costco-total', label: '**** TOTAL', value: '       27.51  ', isBold: false, isLarge: false, isInverted: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 40,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'costco-payment',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 15,
        lines: [
          { id: 'costco-check', label: 'Check/Member Prntd', value: '27.51  ', isBold: false, isLarge: false },
          { id: 'costco-change', label: 'CHANGE', value: '0.00  ', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'costco-tax-detail',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 5,
        lines: [
          { id: 'costco-tax-a', label: 'A 8.50% TAX', value: '1.27  ', isBold: false, isLarge: false },
          { id: 'costco-tax-e', label: 'E 3.75% TAX', value: '0.53  ', isBold: false, isLarge: false },
          { id: 'costco-tax-total', label: 'TOTAL TAX', value: '1.80  ', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: false,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'costco-items-count',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'TOTAL NUMBER OF ITEMS SOLD =    5',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'costco-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'left',
        dateTime: '01/03/2026 15:00 219 4 714 62',
        format: 'MM/DD/YYYY HH:mm',
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'costco-operator',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'OP#: 14 Name: WAZOWSKI',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'costco-thankyou',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Thank You!\nPlease Come Again',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'costco-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Whse:714 Trm:2 Trn:492 OP:61',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'costco-bottom-divider',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 24,
      },
    },
  ],
};
